import { marked } from 'marked'

const asciiChartSet_en2c = {
  '&nbsp;': ' ',
  '&excl;': '!',
  '&quot;': '"',
  '&num;': '#',
  '&dollar;': '$',
  '&percnt;': '%',
  '&amp;': '&',
  '&apos;': "'",
  '&lpar;': '(',
  '&rpar;': ')',
  '&ast;': '*',
  '&plus;': '+',
  '&comma;': ',',
  '&hyphen;': '-',
  '&period;': '.',
  '&sol;': '/',
  '&colon;': ':',
  '&semi;': ';',
  '&lt;': '<',
  '&equals;': '=',
  '&gt;': '>',
  '&quest;': '?',
  '&commat;': '@',
  '&lsqb;': '[',
  '&bsol;': '\\',
  '&rsqb;': ']',
  '&circ;': '^',
  '&lowbar;': '_',
  '&grave;': '`',
  '&lcub;': '{',
  '&verbar;': '|',
  '&rcub;': '}',
  '&tilde;': '~',
}

export function extractTextFromMarkdown(markdown = '') {
  const tokens = marked.lexer(markdown)
  let text = ''
  tokens.forEach(token => {
    if (token.type === 'paragraph' || token.type === 'text') {
      // 使用正则表达式去除Markdown语法符号
      let plainText = token.text.replace(/[_*~`]/g, '')
      // 去掉超链接
      plainText = plainText.replace(/\[(.*?)\]\(.*?\)/g, '$1')
      plainText = plainText.replace(/[\[\]]/g, '')
      text += plainText
    }
  })
  return text.replace(/(<([^>]+)>)/gi, '').replace(/(&.+?;)/g, function (matched) {
    const rs = asciiChartSet_en2c[matched]
    return rs == undefined ? '' : rs
  }) // 去掉 html 标签
}
